module.exports = __webpack_public_path__ + "img/featureLocked.f0983e71.svg";